// ช่องวางปุ่ม 3 ขีดของ Global Menu (เมนูข้ามระบบในเครือ)
//
// สคริปต์ /global-menu.js หาช่องด้วย [data-global-menu] แล้ว "วางปุ่มครั้งเดียวตอนโหลด"
// ถ้าโหลดสคริปต์จาก index.html แบบ defer มันจะทำงานก่อน React วาง DOM เสร็จ →
// หาช่องไม่เจอ แล้วไปลอยที่มุมซ้ายบนของจอ จึงต้องให้ component นี้เป็นคนโหลดสคริปต์
// หลังช่องมีจริงแล้ว (สคริปต์เป็นของกลางที่อีก 3 ระบบใช้อยู่ — ห้ามแก้ให้รอ React)
//
// ปัญหาที่ตามมา: ทุกหน้า render <Topbar> ของตัวเอง พอเปลี่ยนหน้า React ทิ้ง span เดิม
// แล้วสร้างใหม่ที่ว่างเปล่า ส่วนสคริปต์วางปุ่มไปแล้วและไม่ทำงานซ้ำ → ปุ่มหายถาวร
// จนกว่าจะ refresh ทั้งหน้า
//
// วิธีแก้: ย้ายตัวปุ่มไปพักไว้นอก React ตอน unmount แล้วย้ายกลับตอน mount ใหม่
// ใช้ element เดิมทั้งก้อน จึงไม่ต้องผูก event ใหม่และไม่ต้องแตะสคริปต์กลาง
import { useEffect, useRef } from "react";

const SRC = "/global-menu.js";
const PARK_ID = "gm-park";

/** ที่พักปุ่มระหว่างเปลี่ยนหน้า — ซ่อนไว้นอกสายตา ไม่ใช่ลบทิ้ง */
function park(): HTMLElement {
  let el = document.getElementById(PARK_ID);
  if (!el) {
    el = document.createElement("div");
    el.id = PARK_ID;
    el.hidden = true;
    document.body.appendChild(el);
  }
  return el;
}

export function GlobalMenuSlot() {
  const slot = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const el = slot.current;
    if (!el) return;

    const parked = park().querySelector<HTMLElement>(".gm-btn");
    if (parked) {
      // เคยวางไว้แล้วในหน้าก่อน — ย้ายของเดิมกลับเข้าช่อง
      el.appendChild(parked);
    } else if (!document.querySelector(`script[src="${SRC}"]`)) {
      const s = document.createElement("script");
      s.src = SRC;
      document.body.appendChild(s);
    }

    return () => {
      // เก็บปุ่มก่อน React ทิ้ง span นี้ ไม่งั้นปุ่มหายไปกับมัน
      const btn = el.querySelector<HTMLElement>(".gm-btn");
      if (btn) park().appendChild(btn);
    };
  }, []);

  return <span className="gm-slot" data-global-menu ref={slot} />;
}
